module.exports = __webpack_public_path__ + "./docs/img/dotnet.09f8a3e52c88a52343103603c0b80e0a.svg";